import { CheckCircle2 } from "lucide-react";
import { Reveal, waLink } from "./shared";

const VALUES = ["Reliable", "Fast", "Professional"];

export const WhyAFZ = () => (
  <section id="why" data-testid="why-afz-section" className="relative py-24 sm:py-32 bg-void overflow-hidden">
    <div className="absolute top-1/4 -left-32 w-[26rem] h-[26rem] rounded-full bg-brand-cyan/8 blur-[140px] pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <div>
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-cyan mb-4">
            Your Local IT Partner
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase leading-[0.95] tracking-tight text-white">
            Quality service.<br />
            <span className="text-brand-lime text-glow-lime">Expert support.</span><br />
            Complete solutions.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-6 text-base text-slate-400 max-w-lg leading-relaxed">
            One stop. Complete IT solutions. Peace of mind. From a cracked
            MacBook screen to a full small-office network — AFZ repairs,
            protects, connects and supports the tech you rely on.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-8 space-y-4">
            {VALUES.map((v) => (
              <div key={v} className="flex items-center gap-4">
                <CheckCircle2 className="w-7 h-7 text-brand-lime drop-shadow-[0_0_10px_rgba(170,255,0,0.5)]" />
                <span className="font-display text-2xl font-bold uppercase tracking-wide text-white">{v}</span>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.32}>
          <a
            data-testid="why-afz-cta-button"
            href={waLink("Hi AFZ Tech Solution, I'd like to talk about IT support for my device/business.")}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-9 inline-flex items-center gap-2 border border-brand-lime text-brand-lime font-display font-bold uppercase px-7 py-3.5 rounded-full hover:bg-brand-lime hover:text-void transition-all duration-300"
          >
            Talk to a Technician
          </a>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="relative">
        <div className="relative clip-corner border border-brand-cyan/40 overflow-hidden shadow-[0_0_50px_rgba(34,211,238,0.15)]">
          <img
            src="/assets/collateral-quality.jpg"
            alt="AFZ quality service, expert support, complete solutions"
            className="w-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-void/60 via-transparent to-transparent" />
        </div>
        <div className="absolute -top-4 -right-4 w-24 h-24 border-t-2 border-r-2 border-brand-lime/60 rounded-tr-3xl pointer-events-none" />
        <div className="absolute -bottom-4 -left-4 w-24 h-24 border-b-2 border-l-2 border-brand-cyan/60 rounded-bl-3xl pointer-events-none" />
      </Reveal>
    </div>
  </section>
);
